/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Absences_Create_ReasonInputs */

const en_forms_absences_create_reason = /** @type {(inputs: Forms_Absences_Create_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reason`)
};

const de_forms_absences_create_reason = /** @type {(inputs: Forms_Absences_Create_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grund`)
};

/**
* | output |
* | --- |
* | "Reason" |
*
* @param {Forms_Absences_Create_ReasonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_absences_create_reason = /** @type {((inputs?: Forms_Absences_Create_ReasonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Absences_Create_ReasonInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_absences_create_reason(inputs)
	return de_forms_absences_create_reason(inputs)
});